"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _PagePrevious["default"];
  }
});

var _PagePrevious = _interopRequireDefault(require("../lib/icons/legacy/PagePrevious"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
